// Document Vault vocabulary (PROMPT 13)
export { TONE, optOf, labelOf, toneOf, prettify } from "@/config/tone";
export { VISIBILITIES } from "@/config/commOptions";

export const DOCUMENT_CATEGORIES = [
  { value: "intake_form", label: "Intake form", tone: "sky" },
  { value: "consultation_notes", label: "Consultation notes", tone: "sky" },
  { value: "family_action_plan", label: "Family action plan", tone: "navy" },
  { value: "poa_document", label: "POA document", tone: "red" },
  { value: "property_photos", label: "Property photos", tone: "khaki" },
  { value: "property_deed", label: "Property deed / title", tone: "red" },
  { value: "repair_estimates", label: "Repair estimates", tone: "amber" },
  { value: "facility_brochures", label: "Senior facility brochures", tone: "khaki" },
  { value: "placement_agreements", label: "Placement agreements", tone: "navy" },
  { value: "partner_agreements", label: "Partner agreements", tone: "navy" },
  { value: "contractor_estimates", label: "Contractor estimates", tone: "amber" },
  { value: "real_estate_contracts", label: "Real estate contracts", tone: "green" },
  { value: "purchaser_agreements", label: "Purchaser agreements", tone: "green" },
  { value: "invoices", label: "Invoices", tone: "amber" },
  { value: "receipts", label: "Receipts", tone: "amber" },
  { value: "closing_documents", label: "Closing documents", tone: "green" },
  { value: "other", label: "Other", tone: "gray" },
];
